/* Infinite Scroll for Collection Pages — re-initializes on filter/sort, abortable */
(function () {
  'use strict';

  var state = null;

  function findGrid() { return document.querySelector('#product-grid'); }
  function findPagination() { return document.querySelector('.pagination-wrapper'); }

  function getNextUrl(pw) {
    var link = pw && pw.querySelector('a[aria-label="Next page"]');
    if (!link) return null;
    var href = link.getAttribute('href');
    if (!href) return null;
    try { return new URL(href, location.origin).href; } catch (e) { return link.href || null; }
  }

  function appendItemsInto(target, items) {
    var ul = target.tagName === 'UL' ? target : (target.querySelector('ul.product-grid, ul') || target);
    items.forEach(function (item) {
      item.classList.remove('scroll-trigger--offscreen');
      item.classList.add('scroll-trigger--cancel');
      ul.appendChild(item);
    });
  }

  function cleanup() {
    if (state) {
      try { state.observer && state.observer.disconnect(); } catch (e) {}
      try { state.abort && state.abort.abort(); } catch (e) {}
      state = null;
    }
    document
      .querySelectorAll('#infinite-scroll-sentinel, #infinite-scroll-spinner, .infinite-scroll-spinner, .infinite-scroll-status')
      .forEach(function (el) { el.remove(); });
  }

  function isStateValid() {
    if (!state) return false;
    if (!document.contains(state.sentinel)) return false;
    if (!document.contains(state.grid)) return false;
    if (!document.contains(state.paginationWrapper)) return false;
    return true;
  }

  function init() {
    var grid = findGrid();
    var pw = findPagination();
    if (!grid || !pw) return;

    // Idempotent: if state still wired to current DOM and pagination next-URL matches, do nothing
    if (isStateValid() && state.grid === grid && state.paginationWrapper === pw) {
      var currentNext = getNextUrl(pw);
      if (currentNext === state.nextPageUrl) return;
    }

    cleanup();

    var nextPageUrl = getNextUrl(pw);
    if (!nextPageUrl) return;

    var spinner = document.createElement('div');
    spinner.className = 'infinite-scroll-spinner';
    spinner.id = 'infinite-scroll-spinner';
    spinner.innerHTML = '<div class="spinner"></div>';
    spinner.style.display = 'none';
    pw.parentNode.insertBefore(spinner, pw);

    var sentinel = document.createElement('div');
    sentinel.id = 'infinite-scroll-sentinel';
    sentinel.style.cssText = 'height:10px;width:100%;display:block;';
    pw.parentNode.insertBefore(sentinel, spinner);

    var loading = false;
    var abort = ('AbortController' in window) ? new AbortController() : null;
    var local = { aborted: false };

    function loadMore() {
      if (local.aborted || loading || !state || !state.nextPageUrl) return;
      loading = true;
      spinner.style.display = 'flex';

      var fetchOpts = { headers: { 'X-Requested-With': 'XMLHttpRequest' } };
      if (abort) fetchOpts.signal = abort.signal;

      fetch(state.nextPageUrl, fetchOpts)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (local.aborted) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          if (!newGrid) return;

          var newItems = Array.prototype.slice.call(
            newGrid.querySelectorAll(':scope > li, :scope ul.product-grid > li, :scope ul.collection-product-list > li')
          );
          if (!newItems.length) newItems = Array.prototype.slice.call(newGrid.querySelectorAll('li'));
          appendItemsInto(grid, newItems);

          var newPag = doc.querySelector('.pagination-wrapper');
          if (newPag && document.contains(pw)) pw.innerHTML = newPag.innerHTML;

          state.nextPageUrl = getNextUrl(pw);

          if (!state.nextPageUrl) {
            try { state.observer.disconnect(); } catch (e) {}
            if (document.contains(spinner) && spinner.parentNode) {
              var status = document.createElement('div');
              status.className = 'infinite-scroll-status';
              status.textContent = 'All products loaded';
              spinner.parentNode.insertBefore(status, spinner);
            }
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          console.error('[infinite-scroll]', err);
        })
        .then(function () {
          loading = false;
          if (document.contains(spinner)) spinner.style.display = 'none';
          // Aggressive chain-load: if user is already within 2500px of sentinel after this load, fetch next
          if (!local.aborted && state && state.nextPageUrl) {
            var rect = sentinel.getBoundingClientRect();
            if (rect.top < window.innerHeight + 2500) loadMore();
          }
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && state && state.nextPageUrl) loadMore(); });
    }, { rootMargin: '2500px 0px' });
    observer.observe(sentinel);

    state = {
      observer: observer,
      sentinel: sentinel,
      spinner: spinner,
      grid: grid,
      paginationWrapper: pw,
      nextPageUrl: nextPageUrl,
      abort: abort,
      local: local,
    };
    // patch cleanup to flip aborted flag for this state's closures
    var prevCleanup = cleanup;
    // (no rebinding needed — cleanup is called externally)
  }

  // Wrap cleanup to also flip the closure-local abort flag
  var originalCleanup = cleanup;
  cleanup = function () {
    if (state && state.local) state.local.aborted = true;
    originalCleanup();
  };

  function safeInit() {
    try { init(); } catch (e) { console.error('[infinite-scroll] init failed', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }

  // Re-init on URL change (filter/sort uses pushState/replaceState).
  // Retry multiple times because the fetch + DOM swap happens AFTER pushState.
  var lastUrl = location.href;
  function urlChanged() {
    if (location.href === lastUrl) return;
    lastUrl = location.href;
    setTimeout(safeInit, 100);
    setTimeout(safeInit, 600);
    setTimeout(safeInit, 1500);
  }
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () { var ret = orig.apply(this, arguments); try { urlChanged(); } catch (e) {} return ret; };
  });
  window.addEventListener('popstate', urlChanged);

  // Backup: watch the STABLE wrapper (#ProductGridContainer) — facets.js replaces its innerHTML
  // on filter/sort, so observing its direct children catches the swap reliably.
  function attachMutationObserver() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) {
      var grid = findGrid();
      container = grid && grid.parentNode ? grid.parentNode : null;
    }
    if (!container) return;
    var debounce;
    var mo = new MutationObserver(function () {
      // Re-init if our state is stale (grid detached) OR not yet inited
      if (!state || !document.contains(state.grid)) {
        clearTimeout(debounce);
        debounce = setTimeout(safeInit, 80);
      }
    });
    mo.observe(container, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachMutationObserver);
  } else {
    attachMutationObserver();
  }
})();
